module.exports = __webpack_public_path__ + "static/scale-model-of-riverwalk-fort-lauderdale-in-fort-lauderdale-florida-9f7dfc9475168c9bd06b9e201a72f506.png";